import Scene360 from "./Scene360";

/**
 * Represents a 360 scene within the player
 */
export default class SceneSplit extends Scene360 {
  /**
   * Takes an image config object and creates the initial 360 scene
   *
   * @example
   * {
   *   url: '/example.jpg',
   *   hotspots: [
   *     {
   *       u: 0,
   *       v: 0.5,
   *       type: 'web',
   *       options: {
   *         url : 'http://google.com'
   *       }
   *     }
   *   ]
   * }
   *
   */
  constructor(player, image, onFullyLoaded = () => {}) {
    super(player, image, onFullyLoaded);
    this.SCENE_NAME = "SceneSplitOther";
    this._player = player;

    this.split = true;
    this.isOther = true;
  }
}
